// File Name: Businessleader.jsx

// import React, { useRef, useState } from "react";
import React, {useRef,useState,useEffect,} from "react";
import img1 from "../../../assets/EMP_whyus/businessleader/img1.webp";
import img2 from "../../../assets/EMP_whyus/businessleader/img2.webp";
import img3 from "../../../assets/EMP_whyus/businessleader/img3.webp";  
import empowerVideo from "../../../assets/EMP_whyus/businessleader/video.mp4";


const tabs = [
  {
    id: "recruit",
    label: "Recruit",
    tag: "RECRUIT",
    title: "Stand Out in a Competitive Job Market",
    desc: "Traditional bi-weekly or monthly pay cycles no longer align with the financial realities many workers face. Get an edge over the competition by offering DailyPay to attract more applicants and hire faster.",
    stat: "69%",
    statText:
      "of Gen Z hourly workers want their earnings available after each shift.",
    image:img1,
  },

  {
    id: "retain",
    label: "Retain",
    tag: "RETAIN",
    title: "Cut Turnover Costs",
    desc: "Replacing an hourly worker is expensive and time-consuming. Offering DailyPay to your employees has a measurable upside for your business.",
    stat: "30%",
    statText:
      "of employers surveyed who offer DailyPay have substantiated a reduction in employee turnover.",
    image:img2,
  },

  {
    id: "engage",
    label: "Engage",
    tag: "ENGAGE",
    title: "Increase Employee Engagement",
    desc: "Financial flexibility helps employees feel more supported, focused, and motivated at work every day.",
    stat: "85%",
    statText:
      "of employees say earned wage access improves their overall financial wellness.",
    image:img3,
  },

  {
    id: "empower",
    label: "Empower",
    tag: "EMPOWER",
    title: "Real Financial Wellness that Works",
    desc: "Financial wellness isn't a one-size-fits-all solution for your team. That's why DailyPay provides personalized tools, helping each employee build stability their own way.",
    stat: "97%",
    statText:
      "of our clients say DailyPay is an important financial wellness benefit for their workers.",
        video: empowerVideo,

  },
];

function Businessleader() {
  const [activeTab, setActiveTab] = useState("recruit");
    // const [activeTab, setActiveTab] = useState("recruit");

  const [isDropdownOpen, setIsDropdownOpen] =
    useState(false);

  const sectionRefs = {
    recruit: useRef(null),
    retain: useRef(null),
    engage: useRef(null),
    empower: useRef(null),
  };

  useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveTab(entry.target.id);
        }
      });
    },
    {
      threshold: 0.5,
    }
  );

  Object.keys(sectionRefs).forEach((key) => {
    if (sectionRefs[key].current) {
      observer.observe(sectionRefs[key].current);
    }
  });

  return () => observer.disconnect();
}, []);

  // TAB CLICK SCROLL
  const handleTabClick = (id) => {
    setActiveTab(id);

    sectionRefs[id].current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
   <section className="relative bg-[white] overflow-visible pb-20">
  
  {/* HEADING */}
  <div className="pt-24 text-center px-6 ">
    <h2
  className="
    text-[#3b1d1e]
    font-serif

    text-[24px]
    sm:text-[28px]
    md:text-[36px]
    lg:text-[42px]
    lg:font-extralight

    font-medium

    leading-[1.1]
    sm:leading-[1.05]
    lg:leading-[1.08]

    tracking-[-1px]

    py-2
    sm:py-3
    lg:py-4

    sm:-mt-[80px]
    md:-mt-[90px]
    lg:-mt-[120px]
  "
>
  Why Business Leaders
  <br />
  Choose DailyPay
</h2>
  </div>

  {/* STICKY TABS */}
<div
  className="
    sticky

    top-[70px]
    sm:top-[78px]
    lg:top-[40px]

    z-30

    bg-[white]

    py-3
    sm:py-4
    lg:py-5

    px-3
    sm:px-4
    lg:px-[60px]
  "
>
<div className="max-w-[1250px] mx-auto px-4">

 {/* MOBILE + TABLET CUSTOM DROPDOWN */}
<div className="flex justify-center lg:hidden">
  <div
    className="
      relative

      w-full

      max-w-[380px]
      sm:max-w-[650px]
      md:max-w-[580px]
    "
  >
    {/* SELECT BUTTON */}
    <button
      onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      className="
        w-full

        h-[50px]
        sm:h-[54px]
        md:h-[58px]
        lg:h-[64px]

        px-4
        sm:px-5

        border
        border-[#d8d1ca]

        rounded-[12px]
        sm:rounded-[14px]

        bg-white

        text-left

        text-[16px]
        sm:text-[18px]
        md:text-[20px]

        font-semibold

        text-[#4b0000]

        flex
        items-center
        justify-between
      "
    >
      {
        tabs.find((tab) => tab.id === activeTab)?.label
      }

      <span
        className={`
          transition-transform
          duration-300

          ${
            isDropdownOpen
              ? "rotate-180"
              : ""
          }
        `}
      >
        
      </span>
    </button>

    {/* DROPDOWN MENU */}
    {isDropdownOpen && (
      <div
        className="
          absolute

          top-full
          left-0

          mt-2

          w-full

          bg-white

          border
          border-[#d8d1ca]

          rounded-[14px]

          shadow-xl

          overflow-hidden

          z-[999]
        "
      >
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => {
              handleTabClick(tab.id);
              setIsDropdownOpen(false);
            }}
            className={`
              w-full
              px-5
              py-4

              text-left

              text-[16px]
              sm:text-[18px]

              font-semibold

              transition-all
              duration-200

              ${
                activeTab === tab.id
                  ? "bg-[#4b0000] text-white"
                  : "bg-white text-[#4b0000] hover:bg-[#f5f5f3]"
              }
            `}
          >
            {tab.label}
          </button>
        ))}
      </div>
    )}
  </div>
</div>
 {/* DESKTOP TABS */}
<div
  className="
    hidden
    lg:flex

    items-center
    justify-between

    border
    border-[#d8d1ca]

    rounded-full

    bg-white

    shadow-sm

    w-full
    max-w-[1000px]

    mx-auto

    p-2

    lg:mt-[40px]
  "
>
  {tabs.map((tab) => (
    <button
      key={tab.id}
      onClick={() => handleTabClick(tab.id)}
      className={`
        min-w-[180px]
        xl:min-w-[220px]

        h-[54px]
        xl:h-[45px]
        xl:px-6

        text-[20px]
        xl:text-[20px]

        font-semibold

        rounded-full

        transition-all
        duration-300

        ${
          activeTab === tab.id
            ? `
              bg-[#300808]
              text-white
            `
            : `
              text-[#667085]
              hover:text-[#4b0000]
            `
        }
      `}
    >
      {tab.label}
    </button>
  ))}
</div>
</div>
</div>
  {/* CONTENT */}
  <div className="space-y-32 mt-[80px]">
    {tabs.map((tab, index) => (
      <section
        key={tab.id}
          id={tab.id}

        ref={sectionRefs[tab.id]}
        className="
          max-w-[1400px]
          mx-auto

          px-6
          lg:px-10
        "
      >
        <div
          className={`
            grid
            grid-cols-1
            lg:grid-cols-2

             gap-10
            lg:gap-20
             xl:gap-24           
             items-start

            ${
              index % 2 === 0
                ? "lg:[&>*:first-child]:order-2"
                : ""
            }
          `}
        >
          {/* MEDIA */}
<div
  className={`
    ${
      index % 2 === 0
        ? "lg:-mr-[120px]"
        : "lg:-ml-[120px]"
    }
  `}
>
  {tab.id === "empower" ? (
    <video
      controls
      autoPlay
      muted
      loop
      className="
        w-full
        lg:w-[115%]

        h-[320px]
        md:h-[350px]
        lg:h-[380px]

        object-cover
      "
    >
      <source
        src={tab.video}
        type="video/mp4"
      />
    </video>
  ) : (
    <img
      src={tab.image}
      alt={tab.label}
      className="
        w-full
        lg:w-[115%]

        h-[220px]
        lg:h-[420px]

        object-cover
      "
    />
  )}
</div>
          {/* CONTENT */}
<div
  className="
    lg:-ml-[40px]
    xl:-ml-[60px]
  "
>            <span
              className="
                text-[#d45500]
                font-bold
                tracking-[1px]

                text-[14px]
              "
            >
              {tab.tag}
            </span>

            <h3
              className="
                mt-4

                text-[#290001]

                text-[44px]
                lg:text-[48px]
                lg:w-[600px]

                leading-[0.95]
              "
            >
              {tab.title}
            </h3>

            <p
              className="
                mt-6

                text-[20px]
                lg:text-[16px]
                leading-[1.4]

                text-[#111111]
              "
            >
              {tab.desc}
            </p>

            <button
              className="
                mt-4

                text-[22px]
                lg:text-[16px]
                font-semibold

                text-[#111111]
              "
            >
              Learn more →
            </button>

            {/* STAT BOX */}
          <div
  className="
    mt-8
    sm:mt-10
    lg:mt-8

    bg-[#f3e6dc]

    p-5
    sm:p-6
    md:p-7
    lg:p-8

    rounded-[8px]
    sm:rounded-[10px]
    lg:rounded-[12px]

    w-full

    max-w-[280px]
    sm:max-w-[360px]
    md:max-w-[420px]
    lg:max-w-[660px]

    min-h-[100px]
    sm:min-h-[150px]
    md:min-h-[170px]
    lg:min-h-[120px]
  "
>
  <h4
    className="
      text-[42px]
      sm:text-[50px]
      lg:text-[18px]
      lg:-mt-4

      font-bold

      text-[#111111]
    "
  >
    {tab.stat}
  </h4>

  <p
    className="
      mt-2

      text-[18px]
      sm:text-[20px]
      lg:text-[16px]

      leading-[1.4]

      text-[#290001]
    "
  >
    {tab.statText}
  </p>
</div>
          </div>
        </div>
      </section>
    ))}
  </div>
</section>
  );
}

export default Businessleader;